<template>
  <tr>
    <td :class="['text-center']">
      <v-card color="transparent" flat>
        <div
          class="ribbonpromo"
          v-if="item.IndPromo"
          transition="slide-x-transition"
        >
          ¡EN PROMOCIÓN!
        </div>

        <v-avatar tile class="img_art mt-4 mb-n4" size="65">
          <img :src="`${imgSrc(item.Codigo)}`" />
          <!-- <imgPredet
           
            :codart="item.Codigo"
            :urlimg="imgSrc(item.Codigo)"
            :key="updateImg"
          /> -->
        </v-avatar>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            x-small
            color="error"
            dark
            @click="VerificaPedido(item)"
            elevation="0"
          >
            Eliminar
          </v-btn>

          <v-dialog v-model="dialogEliminar.dialog" width="380" persistent>
            <v-card class="elevation-12" color="warning" dark>
              <v-toolbar light flat color="white">
                <v-toolbar-title :class="['d-none', 'd-sm-none', 'd-md-flex']">
                  <v-img
                    contain
                    :src="`${domoapi2_img}Cia/15/logo?archivo=1.png`"
                    id="Home"
                    width="154"
                  ></v-img>
                </v-toolbar-title>

                <v-spacer />
                <v-btn
                  icon
                  color="primary"
                  @click="
                    dialogEliminar = {
                      dialog: false,
                      articulo: {},
                      info: [],
                    }
                  "
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text :class="['text-subtitle-2']">
                ¿ Desea eliminar el articulo ?
                <br />
                {{ dialogEliminar.articulo.Codigo }}
                <br />
                {{ dialogEliminar.articulo.Nombre }}
              </v-card-text>

              <v-card-text v-if="dialogEliminar.info.length !== 0">
                Los siguientes artículos van a cambiar en su promoción si
                continua:
                <ul>
                  <li v-for="(info, index) in dialogEliminar.info" :key="index">
                    {{ info }}
                  </li>
                </ul>
              </v-card-text>

              <v-divider color="#D3BC8D"></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  elevation="0"
                  @click="
                    dialogEliminar = {
                      dialog: false,
                      articulo: {},
                      info: '',
                    };
                    EliminaItem(item.Codigo);
                  "
                >
                  Si
                </v-btn>
                <v-btn
                  color="primary"
                  elevation="0"
                  @click="
                    dialogEliminar = {
                      dialog: false,
                      articulo: {},
                      info: '',
                    };
                    get_ConsultaPedido();
                  "
                >
                  No
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </td>
    <td :class="['text-left']">
      <v-card min-width="240" color="transparent" flat>
        <v-list-item two-line dense>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-2 font-weight-bold">
              {{ item.Codigo }}</v-list-item-title
            >
            <v-list-item-subtitle>{{ item.Nombre }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-action
                @click="articuloRoute(item.Codigo)"
                style="cursor: pointer"
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-action-text class="font-weight-bold"
                  >Ver</v-list-item-action-text
                >
                <v-icon color="primary darken-3">
                  mdi-view-compact-outline
                </v-icon>
              </v-list-item-action>
            </template>
            <span>Ir al Detalle del Artículo</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item two-line v-if="item.Promo !== 0" class="mt-n5">
          <v-list-item-content>
            <v-list-item-title
              >Promo: {{ item.Promo }} - {{ item.Tipo }}</v-list-item-title
            >
            <v-list-item-subtitle class="d-flex">
              <strong>
                <span v-if="item.Paquetes">Paq:</span>
                <span v-else>Min:</span>
              </strong>
              <div :class="['ml-3']">{{ item.CantidadMin }} Unidades</div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </td>
    <td>
      <v-card min-width="90" color="transparent" flat :class="['text-right']">
        <span :class="['text-no-wrap', 'text-subtitle-1']">
          {{ simboloMoneda[tipoMoneda] }}
          {{ item.Precio[tipoMoneda] | numeral("0,0.00") }}
        </span>
      </v-card>
    </td>
    <td>
      <v-card min-width="60" color="transparent" flat :class="['text-center']">
        <span :class="['text-no-wrap', 'text-subtitle-1']">
          {{ item.Descuento | numeral("0,0") }} %
        </span>
      </v-card>
    </td>
    <td>
      <v-card min-width="90" color="transparent" flat :class="['text-right']">
        <span :class="['text-no-wrap', 'text-subtitle-1']">
          {{ simboloMoneda[tipoMoneda] }}
          {{ item.PrecioNeto[tipoMoneda] | numeral("0,0.00") }}
        </span>
      </v-card>
    </td>

    <td :class="['text-center']">
      <v-text-field
        :class="['pt-2', 'mx-auto']"
        color="primary"
        :hide-details="!error"
        dense
        :error="error"
        :label="`${formatNumber(
          contCantidad({ contmayor: item.ContentMayor, cant: cantidadEntera })
        )} ${item.UniVenta}`"
        type="number"
        :rules="[reglaSoloEnteros]"
        :min="1"
        :max="disponibleMayor({ item })"
        style="width: 100px; font-size: 1.1rem"
        filled
        reverse
        v-model.number="cantidadEntera"
        @change="
          item.CantCar < 1
            ? (item.CantCar = item.ContentMayor)
            : (item.CantCar = item.CantCar);
          CalculaItem;
        "
        @input="
          item.CantCar < 1
            ? (item.CantCar = item.ContentMayor)
            : (item.CantCar = item.CantCar);
          CalculaItem;
        "
      ></v-text-field>
      <v-btn
        v-if="item.CantCmb"
        elevation="0"
        x-small
        color="success"
        dark
        @click="CargarItem(item)"
        :disabled="error"
      >
        Actualizar
      </v-btn>
    </td>
    <td>
      <v-card min-width="100" color="transparent" flat :class="['text-right']">
        <span :class="['text-no-wrap', 'text-subtitle-1', 'font-weight-bold']">
          <strong
            >{{ simboloMoneda[tipoMoneda] }}
            {{ item.PrecioTot[tipoMoneda] | numeral("0,0.00") }}</strong
          >
        </span>
      </v-card>
    </td>
  </tr>
</template>

<script>
import imgPredet from "../components/ImgPred";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "CarritoItem",
  data() {
    return {
      imgP: false,
      numeroEntero: "",
      error: false,
      datosPromo: [],
      dialogEliminar: {
        dialog: false,
        articulo: {},
        info: "",
      },
      updateImg: Math.floor(Math.random() * 100),
    };
  },
  components: {
    imgPredet,
  },
  props: {
    item: Object,
  },
  update() {},
  computed: {
    ...mapState([
      "Pedido",
      "tipoMoneda",
      "simboloMoneda",
      "imgPeque",
      "NoImg",
      "loading",
      "domoapi2_img",
    ]),
    ...mapGetters(["filterpromo"]),
    contCantidad: function () {
      return function ({ contmayor, cant }) {
        // return this.validaContenido ? contmayor * cant : cant;
        return contmayor * cant;
      };
    },

    disponibleMayor: function () {
      return function ({ item: { Disponible, ContentMayor, Stock } }) {
        return ContentMayor !== 0 ? Stock : null;
      };
    },
    cantidadEntera: {
      get() {
        return Math.trunc(this.item.CantCar / this.item.ContentMayor);
      },

      set(valor) {
        this.item.CantCar = valor * this.item.ContentMayor;
      },
    },
    CalculaItemCar() {
      // let ItemCar = this.item
      let ItemsPedido = this.Pedido.items;
      let Promociones = this.obtenerPromociones({
        ItemsPedido,
        ItemCar: this.item,
      });

      let PromoAct = this.obtenerPromocionActiva({
        Promociones,
        ItemCar: this.item,
      });

      /* this.aplicarDescuentos({ ItemCar, PromoAct }); */
    },
    ValidaCantidadPromo: function () {
      return function ({ item }) {
        const { IndPromo, Codigo, CantCar } = item;

        let p = [];
        let indexPromo = [];
        if (IndPromo) {
          p = this.Pedido.promocion.filter((x) => {
            return x["Articulo"] === Codigo && CantCar >= x["Cantidad"];
          });
          p.forEach((x) => {
            indexPromo.push(x["Cantidad"]);
          });
        } //si hay promo
        else {
          //no hay promo
        }

        if (p.length > 0) {
          let xindexPromo = indexPromo.reduce(function (prev, curr) {
            return Math.abs(curr - CantCar) < Math.abs(prev - CantCar)
              ? curr
              : prev;
          });
          let findexPromo = indexPromo.findIndex((x) => xindexPromo === x);
          this.datosPromo = p[findexPromo];

          this.item.Promo = this.datosPromo.Promo;
          this.item.CantidadMin = this.datosPromo.min;
          this.item.TipoPromo = this.datosPromo.Tipo;
          this.item.Descuento = this.datosPromo.descuento;
          this.item.CantCmb =
            this.item.CantCar !== this.item.Cantidad ? true : false;
          //this.CalculaPrecio()
          /* this.set_AdPromoT();
        this.$emit("promoArticulo", p, CantCar, true, Codigo); */
          return true;
        } else {
          this.datosPromo = [];
          /*  this.set_AdPromoF();
        this.$emit("promoArticulo", [], CantCar, false, null); */
          return false;
        }
      };
    },

    obtenerPromocionActiva: function () {
      return function ({ Promociones, ItemCar }) {
  
        let PromoAct = {},
          PromoRangos = [
            {
              Articulo: ItemCar.Codigo,
              Codigo: 0,
              Tipo: "",
              PrecioNeto: ItemCar.PrecioNeto,
              descuento: 0,
              CantCar: 0,
              min: ItemCar.Contenido,
              max: ItemCar.Contenido,
              pos: 0,
            },
          ];
        const { PromoDisp, Promos, ComboEsp } = Promociones;
        if (PromoDisp) {
          let i = 0;
          let Articulo = ItemCar.Codigo;
          Promos.forEach((p) => {
            if (
              Object.entries(p.Articulos.filter((f) => f === Articulo))
                .length !== 0
            ) {
              PromoRangos.push({
                Articulo,
                Codigo: p.Codigo,
                Tipo: p.Tipo,
                descuento: p.Descuento,
                CantCar: p.CantCar,
                min: p.Cantidad,
                max: p.Cantidad,
                pos: i,
              });
              PromoRangos[i].max = p.Cantidad;
              i++;
            }
          });
        }
        PromoAct = PromoRangos.filter((f) =>
          f.min !== f.max && f.CantCar > 0
            ? f.CantCar >= f.min && f.CantCar < f.max
            : f.CantCar >= f.min
        )[0];
        if (!PromoAct) {
          PromoAct = PromoRangos.filter((f) =>
            f.min !== f.max
              ? this.item.CantCar >= f.min && this.item.CantCar < f.max
              : this.item.CantCar >= f.min
          )[0];
        }
        return PromoAct;
      };
    },
    aplicarDescuentos: function () {
      return function ({ ItemCar, PromoAct }) {
        // Code
      };
    },
    obtenerPromociones: function () {
      return function ({ ItemsPedido, ItemCar }) {
        let Promos = [],
          PromoDisp = false,
          ComboEsp = false;
        ItemsPedido.forEach((itm) => {
          itm.Promociones.forEach((prom) => {

            if (prom.Articulo === ItemCar.Codigo) {
              PromoDisp = true;

              if (prom.TipoPromo === "Combo Especial") {
                ComboEsp = true;

              }
            }
            if (Promos[prom.Codigo]) {
              Promos[prom.Codigo].Codigo = prom.Codigo;
              Promos[prom.Codigo].Articulos.push(prom.Articulo);
              Promos[prom.Codigo].Tipo = prom.TipoPromo;
              Promos[prom.Codigo].Descuento = prom.Descuento;
              Promos[prom.Codigo].Cantidad = prom.Cantidad;
              Promos[prom.Codigo].CantCar += itm.CantCar;
            } else {
              Promos[prom.Codigo] = {
                Codigo: prom.Codigo,
                Articulos: [prom.Articulo],
                Tipo: prom.Tipo,
                Descuento: prom.Descuento,
                Cantidad: prom.Cantidad,
                CantCar: itm.CantCar,
              };
            }
          });
        });
        return { PromoDisp, Promos, ComboEsp };
      };
    },

    CalculaItem() {
      let ItemCar = this.item,
        Promociones = ItemCar.Promociones,
        PromoAct = {},
        PromoRangos = [
          {
            Articulo: ItemCar.Codigo,
            Codigo: 0,
            Tipo: "",
            PrecioNeto: ItemCar.PrecioNeto,
            descuento: 0,
            CantCar: 0,
            min: ItemCar.ContentMayor,
            max: ItemCar.ContentMayor,
            pos: 0,
          },
        ],
        Promos = [],
        PromoDisp = false,
        ComboEsp = false,
        ComboArt = [];

      this.Pedido.items.forEach((itm) => {
        itm.Promociones.forEach((prom) => {
          if (prom.Articulo === ItemCar.Codigo) {
            PromoDisp = true;
            if (prom.TipoPromo === "Combo Especial") {
              ComboEsp = true;
            }
          }

          if (PromoDisp) {
            if (Promos[prom.Codigo]) {
              Promos[prom.Codigo].Codigo = prom.Codigo;
              Promos[prom.Codigo].Articulos.push(prom.Articulo);
              Promos[prom.Codigo].Tipo = prom.TipoPromo;
              Promos[prom.Codigo].Descuento = prom.Descuento;
              Promos[prom.Codigo].Cantidad = prom.Cantidad * itm.ContentMayor;
              Promos[prom.Codigo].CantCar += itm.CantCar;
            } else {
              Promos[prom.Codigo] = {
                Codigo: prom.Codigo,
                Articulos: [prom.Articulo],
                Tipo: prom.TipoPromo,
                Descuento: prom.Descuento,
                Cantidad: prom.Cantidad * itm.ContentMayor,
                CantCar: itm.CantCar,
              };
            }
          }
        });
      });

      this.item.PrecioNeto = [
        this.item.Precio[0] - this.item.Precio[0] * (this.item.Descuento / 100),
        this.item.Precio[1] - this.item.Precio[1] * (this.item.Descuento / 100),
      ];
      this.item.PrecioTot = [
        this.item.PrecioNeto[0] * this.item.CantCar,
        this.item.PrecioNeto[1] * this.item.CantCar,
      ];

      if (PromoDisp) {
        let i = 0;
        const Articulo = ItemCar.Codigo;
        Promos.forEach((p) => {
          if (
            Object.entries(p.Articulos.filter((f) => f === Articulo)).length !==
            0
          ) {
            PromoRangos.push({
              Articulo: Articulo,
              Codigo: p.Codigo,
              Tipo: p.Tipo,
              descuento: p.Descuento,
              CantCar: p.CantCar,
              min: p.Cantidad,
              max: p.Cantidad,
              pos: i,
            });
            PromoRangos[i].max = p.Cantidad;
            i++;
          }
        });
      }

      PromoAct = PromoRangos.filter((f) =>
        f.min !== f.max && f.CantCar > 0
          ? f.CantCar >= f.min && f.CantCar < f.max
          : f.CantCar >= f.min
      )[0];

      if (!PromoAct) {
        PromoAct = PromoRangos.filter((f) =>
          f.min !== f.max
            ? this.item.CantCar >= f.min && this.item.CantCar < f.max
            : this.item.CantCar >= f.min
        )[0];
      }

      if (ComboEsp) {
        ComboArt = Promos[Promociones[0].Codigo]
          ? Promos[Promociones[0].Codigo].Articulos
          : [ItemCar.Codigo];

        this.Pedido.items.forEach((itm) => {
          if (
            Object.entries(ComboArt.filter((f) => f === itm.Codigo)).length !==
              0 &&
            !!PromoAct
          ) {
            itm.CantCmb = false;
            itm.Promo = PromoAct.Codigo;
            itm.CantidadMin = PromoAct.min;
            itm.TipoPromo = PromoAct.Tipo;
            itm.Descuento = PromoAct.descuento;
            itm.PrecioNeto = [
              itm.Precio[0] - itm.Precio[0] * (itm.Descuento / 100),
              itm.Precio[1] - itm.Precio[1] * (itm.Descuento / 100),
            ];
            itm.PrecioTot = [
              itm.PrecioNeto[0] * itm.CantCar,
              itm.PrecioNeto[1] * itm.CantCar,
            ];
            itm.MontoIVA = [
              itm.PrecioTot[0] * itm.PorcentIva,
              itm.PrecioTot[1] * itm.PorcentIva,
            ];
            itm.CantCmb =
              itm.CantCar !== itm.Cantidad ||
              itm.Descuento !== PromoAct.Descuento
                ? true
                : false;
          }
        });
      } else {
        this.item.Promo = PromoAct.Codigo;
        this.item.CantidadMin = PromoAct.min;
        this.item.TipoPromo = PromoAct.Tipo;
        this.item.Descuento = PromoAct.descuento;
        this.item.PrecioNeto = [
          this.item.Precio[0] -
            this.item.Precio[0] * (this.item.Descuento / 100),
          this.item.Precio[1] -
            this.item.Precio[1] * (this.item.Descuento / 100),
        ];
        this.item.PrecioTot = [
          this.item.PrecioNeto[0] * this.item.CantCar,
          this.item.PrecioNeto[1] * this.item.CantCar,
        ];
        this.item.MontoIVA = [
          this.item.PrecioTot[0] * this.item.PorcentIva,
          this.item.PrecioTot[1] * this.item.PorcentIva,
        ];
        this.item.CantCmb =
          this.item.CantCar !== this.item.Cantidad ? true : false;
      }

      this.get_calculaCarrito();

      return this.item;
    },
    imgSrc() {
      return function (id) {
        let xSrc = this.domoapi2_img;
        xSrc += "Articulo/";
        xSrc += this.ChrEsp(id);
        xSrc += "/Principal?";
        xSrc += "Cia=15";
        return xSrc;
      };
    },
  },
  methods: {
    ...mapMutations([
      "CLR_PROMO",
      "CLR_DATOS_ART",
      "set_mensaje",
      "set_AdPromoF",
      "set_AdPromoT",
    ]),
    ...mapActions([
      "cargarDatosPromo",
      "get_ConsultaPedido",
      "set_updateArtCarrito",
      "set_eliminaArtCarrito",
      "get_calculaCarrito",
    ]),
    reglaSoloEnteros(valor) {
      const esValido = !valor || /^\d+$/.test(valor);
      this.error = !esValido; // Actualiza la variable error según la validación
      return esValido || "Solo Enteros";
    },
    isNumber: function (evt) {
      let charCode = evt.which ? evt.which : evt.keyCode;
      let inputElement = evt.target;
      let currentValue = inputElement.value;
      let newValue = parseFloat(currentValue + String.fromCharCode(charCode));
      let isMaximo = newValue > this.disponibleMayor({ item: this.item });

      if (isMaximo) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    formatNumber(num) {
      return parseFloat(num).toFixed(2);
    },
    articuloRoute(codart) {
      this.CLR_PROMO();
      this.CLR_DATOS_ART();
      this.cargarDatosPromo({ codart: codart });
      codart = encodeURIComponent(codart);
      this.$vuetify.goTo(0);
      return this.$router.push("/articulo/" + codart);
    },
    CalculaPrecio() {
      this.item.PrecioNeto = [
        this.item.Precio[0] - this.item.Precio[0] * (this.item.Descuento / 100),
        this.item.Precio[1] - this.item.Precio[1] * (this.item.Descuento / 100),
      ];
      this.item.PrecioTot = [
        this.item.PrecioNeto[0] * this.item.CantCar,
        this.item.PrecioNeto[1] * this.item.CantCar,
      ];
    },

    async CargarItem(xitem) {
      let Arts = "",
        Cants = "",
        Proms = "";
      await this.Pedido.items.forEach(async (itm) => {
        if (itm.CantCmb) {
          if (Arts === "" && Cants === "") {
            Arts = `${itm.Codigo}`;
            Cants = `${itm.CantCar}`;
            Proms = `${itm.Promo}`;
          } else {
            Arts += `,${itm.Codigo}`;
            Cants += `,${itm.CantCar}`;
            Proms += `,${itm.Promo}`;
          }
        }
      });
      if (Arts === "" && Cants === "" && Proms === "") {
        Arts = xitem.Codigo;
        Cants = xitem.CantCar;
        Proms = this.Promo;
      }
      await this.set_updateArtCarrito({
        articulo: Arts,
        cantidad: Cants,
        promo: Proms,
      });
      this.set_mensaje({
        Visible: true,
        Msj: "Articulo Actuaizado",
        Type: "success",
      });
    },
    async EliminaItem(xcod) {
      let Arts = "",
        Cants = "",
        Proms = "";

      await this.Pedido.items.forEach(async (itm) => {
        if (itm.CantCmb) {
          if (Arts === "" && Cants === "") {
            Arts = `${itm.Codigo}`;
            Cants = `${itm.CantCar}`;
            Proms = `${itm.Promo}`;
          } else {
            Arts += `,${itm.Codigo}`;
            Cants += `,${itm.CantCar}`;
            Proms += `,${itm.Promo}`;
          }
        }
      });

      await this.set_eliminaArtCarrito({
        articulo: xcod,
      });

      if (Arts !== "" && Cants !== "" && Proms !== "") {
        await this.set_updateArtCarrito({
          articulo: Arts,
          cantidad: Cants,
          promo: Proms,
        });
      }

      this.set_mensaje({
        Visible: true,
        Msj: "Articulo Eliminado",
        Type: "success",
      });
      await this.get_ConsultaPedido();
    },
    async VerificaPedido(vItem) {
      let PromoAct = {},
        PromoRangos = [
          {
            Codigo: 0,
            Tipo: "",
            descuento: 0,
            CantCar: 0,
            min: vItem.ContentMayor,
            max: vItem.ContentMayor,
            pos: 0,
          },
        ],
        Promos = [],
        xInfo = [];

      if (vItem.Tipo === "Combo Especial") {
        this.Pedido.items.forEach((itm) => {
          itm.Promociones.forEach((prom) => {
            if (prom.TipoPromo === vItem.Tipo) {
              if (Promos[prom.Codigo]) {
                Promos[prom.Codigo].Codigo = prom.Codigo;
                Promos[prom.Codigo].Articulos.push(prom.Articulo);
                Promos[prom.Codigo].Tipo = prom.TipoPromo;
                Promos[prom.Codigo].Descuento = prom.Descuento;
                Promos[prom.Codigo].Cantidad = prom.Cantidad;
                Promos[prom.Codigo].CantCar +=
                  prom.Articulo !== vItem.Codigo ? itm.CantCar : 0;
              } else {
                Promos[prom.Codigo] = {
                  Codigo: prom.Codigo,
                  Articulos: [prom.Articulo],
                  Tipo: prom.TipoPromo,
                  Descuento: prom.Descuento,
                  Cantidad: prom.Cantidad,
                  CantCar: prom.Articulo !== vItem.Codigo ? itm.CantCar : 0,
                };
              }
            }
          });
        });

        let i = 0;

        Promos.forEach((p) => {
          if (
            Object.entries(p.Articulos.filter((f) => f === vItem.Codigo))
              .length !== 0
          ) {
            PromoRangos.push({
              Codigo: p.Codigo,
              Tipo: p.Tipo,
              descuento: p.Descuento,
              CantCar: p.CantCar,
              min: p.Cantidad * vItem.ContentMayor,
              max: p.Cantidad * vItem.ContentMayor,
              pos: i,
            });
            PromoRangos[i].max = p.Cantidad * vItem.ContentMayor;
            i++;
          }
        });
      }

      PromoRangos.forEach((x) => {

        if (x.CantCar === 0) {
          PromoAct = x;
        } else if (x.CantCar >= x.min && x.CantCar < x.max) {
          PromoAct = x;
        } else if (x.CantCar >= x.min) {
          PromoAct = x;
        }

      });

     

      this.Pedido.items.forEach((itm) => {
        if (
          itm.Codigo !== vItem.Codigo &&
          itm.Promo === vItem.Promo &&
          vItem.Tipo === "Combo Especial"
        ) {
          //(PromoAct.Codigo)
          itm.Promo = PromoAct.Codigo;
          itm.CantCmb = true;
          xInfo.push(itm.Codigo);
        }
      });

      this.dialogEliminar = {
        dialog: true,
        articulo: this.item,
        info: xInfo,
      };
    },
    ChrEsp(chr) {
      const chrSplit = chr.split("");
      let newChr = "";

      chrSplit.forEach((x) => {
        if (x === "/") newChr += "-";
        else if (x === ".") newChr += "-";
        else newChr += x;
      });

      return newChr;
    },
  },
};
</script>
<style scoped>
.ribbonpromo {
  z-index: 1;
  position: absolute;
  top: 2px;
  left: 2px;
  width: 95px;
  display: block;
  padding: 1px;
  font-size: 10px;
  border-radius: 5px;
  background-color: #d3bc8d;
  color: #7c2629;
  text-align: center;
  border-left: 2px solid #b05954 !important;
  border-top: 2px solid #b05954 !important;
}
</style>
